import { memo } from "react";
import Image from "next/image";
import PropTypes from "prop-types";
import { useRouter } from "next/router";

const Component1 = memo(({ className = "", carbongrowth, title, content }) => {
  const router = useRouter();
  const lang = router.locale || "en";
  return (
    <div
      className={`self-stretch flex-1 rounded-3xl border-gray-500 border-solid border-[1px] flex flex-col items-start justify-between p-5 gap-[40px] text-5xl text-text-primary  ${className}`}
      each
      card
      is
      of
      max
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      <Image
        className="w-11 h-11 overflow-hidden shrink-0"
        loading="lazy"
        width={44}
        height={44}
        alt={title}
        src={carbongrowth}
      />
      <div className="flex flex-col gap-[15px]">
        <h3
          className="m-0 text-[24px] leading-[140%] font-medium font-[inherit] rich-text"
          dangerouslySetInnerHTML={{
            __html: title || "",
          }}
        />

        <p className="text-[16px] leading-[150%] h-[18vh]">{content}</p>
      </div>
    </div>
  );
});

Component1.propTypes = {
  className: PropTypes.string,
  carbongrowth: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default Component1;
